/* eslint-disable */
import { Component } from 'react';
import PropTypes from 'prop-types';
import assign from 'lodash/assign';
import get from 'lodash/get';
import axios from 'axios';

// import NewsletterModel from '../../../models/newsletter_module';
// import sendGASubscriptionEvents from '../../../utils/newsletter_ga_util';

// let scriptjs;

class NewsletterSubscriber extends Component {
  constructor(props) {
    super();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.handleEmailUpdate = this.handleEmailUpdate.bind(this);
    this.handleVerify = this.handleVerify.bind(this);
    this.handleInputFocus = this.handleInputFocus.bind(this);

    this.statusMessages = {
      normal: "You're subscribed",
      error: 'There was an error. Please Try Again',
      loading: 'Loading'
    };

    const config = get(props, 'config');
    const allNewsletterData = get(config, 'newsletters.listsBySlug');
    const newslettersState = {};
    const newsletterIds = props.newsletterIds || [];
    props.newsletters.forEach(function mapPropsToState(newsletterObj) {
      const listPropName = get(newsletterObj, 'list');
      const listId = get(allNewsletterData, listPropName);

      newslettersState[listId] = !!newsletterObj.default;
    });

    // hack until i refactor this
    newsletterIds.forEach(function mapPropsToState(id) {
      newslettersState[id] = false;
    });
    this.state = {
      email: '',
      newsletters: newslettersState,
      shouldDisplayReCaptcha: false
    };
  }

  handleInputFocus() {
    if (!this.state.shouldDisplayReCaptcha) {
      this.setState({
        shouldDisplayReCaptcha: true
      });
    }
  }
  handleUpdate(e) {
    const { target } = e;
    const { name, checked } = target;
    const newNewsletterState = assign({}, this.state.newsletters, {
      [name]: checked
    });
    this.setState({
      newsletters: newNewsletterState
    });
  }

  handleEmailUpdate(e) {
    const { target } = e;
    const { value } = target;
    this.setState({
      email: value
    });
  }

  handleVerify(value) {
    this.setState({ recaptcha: value });
  }


  handleSubmit(e) {
    // console.log('call revue', this.state.email);
    e.preventDefault();
    const actualListId = get(e.target.listId, 'value', 497);
    const savedEmail = this.state.email;
    const emailRegex = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    const emailStatus = emailRegex.test(savedEmail);
    const captcha = this.state.recaptcha;

    let data = {
      email: savedEmail,
      listId: actualListId,
      first_name: 'new',
      last_name: 'user',
      double_opt_in: false
    };

    if (
      emailStatus &&
      captcha !== undefined
    ) {
      // console.log('clean req');
      const webApiUrl =
        'https://tempo.inc.com/getrevue/add/';
      const tokenStr = 'iHKTPKgaDUSYFKnbsZlEnbPT119pM-3e';
      axios
        .post(
          webApiUrl,
          data,
          {
            headers: {
              Authorization: `Token ${tokenStr}`
            },
          }
        )
        .then(response => {
          if (response.status === 200 ) {
            this.setState({
              disabled: true,
              status: "You're Now Subscribed!",
              email: "You're Now Subscribed!",
              shouldDisplayReCaptcha: false
            });
          }
        })
        .catch(err => {
          // console.log('AXIOS ERROR: ', err.response);
          this.setState({
            disabled: false,
            status: err.response.data.error.email[0]
          });
        });
    } else {
      this.setState({ disabled: false, status: 'Please Try Again'});
    }


    // // console.log('handle submit', e);
    // // e.preventDefault();
    // const savedEmail = this.state.email;
    // // console.log('saved email', this.state.email);
    // const emailRegex = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    // const emailStatus = emailRegex.test(savedEmail);
    // const newsletters = Object.keys(this.state.newsletters) || [];
    // const selectedNewsletters = newsletters.filter(
    //   function filterNewsletterList(listId) {
    //     return this.state.newsletters[listId];
    //   }.bind(this)
    // );
    // const captcha = this.state.recaptcha;
    // // console.log('email status', emailStatus);
    // // console.log('captcha', captcha);
    // // console.log('selected newsletters', selectedNewsletters.length);

    // if (
    //   emailStatus &&
    //   // selectedNewsletters.length > 0 &&
    //   captcha !== undefined
    // ) {
    //   this.setState(
    //     { disabled: true, status: 'loading', email: '' }, // eslint-disable-line react/no-unused-state
    //     function disbaledSetStateCallback() {
    //       const currUrl = get(this.props.config, 'navHistory[0]');
    //       const data = {
    //         email: savedEmail,
    //         lists: selectedNewsletters,
    //         sourceDescription: currUrl,
    //         recaptcha: this.state.recaptcha
    //       };

    //       // console.log('newsletters', newsletters);
    //       // console.log('selected newsletters', selectedNewsletters);
    //       // console.log('currUrl', currUrl);
    //       // console.log('data', data);
    //       new NewsletterModel()
    //         .post(data, this.props.config)
    //         .then(
    //           function receiveResponse(response) {
    //             console.log('recieve response', response);
    //             sendGASubscriptionEvents(
    //               data.lists,
    //               this.props.config.newsletters
    //             );
    //             this.setState({
    //               disabled: false, // eslint-disable-line react/no-unused-state
    //               // eslint-disable-next-line no-use-before-define
    //               status:
    //                 get(response, 'data.[0].status', '').toLowerCase() ===
    //                   'normal' || get(response, 'status', '') === 200
    //                   ? "You're subscribed!"
    //                   : get(response, 'data.[0].status', '').toLowerCase() // eslint-disable-line react/no-unused-state
    //             });
    //           }.bind(this)
    //         )
    //         .catch(
    //           function handleUserError() {
    //             // change this to err.status after 400 issue is fixed
    //             this.setState({
    //               disabled: false, // eslint-disable-line react/no-unused-state
    //               status: 'error', // eslint-disable-line react/no-unused-state
    //               error: true // eslint-disable-line react/no-unused-state
    //             }); // eslint-disable-line react/no-unused-state
    //           }.bind(this)
    //         );
    //     }.bind(this)
    //   );
    // } else {
    //   // console.log('email fails test');
    //   this.setState({ disabled: false, status: 'Please Try Again' }); // eslint-disable-line react/no-unused-state
    // }
  }
}

NewsletterSubscriber.defaultProps = {
  newsletters: [],
  newsletterIds: []
};

NewsletterSubscriber.propTypes = {
  newsletters: PropTypes.arrayOf(PropTypes.shape({})),
  newsletterIds: PropTypes.arrayOf(PropTypes.number),
  config: PropTypes.shape({
    newsletters: PropTypes.shape({}).isRequired
  }).isRequired
};

export default NewsletterSubscriber;
